<template>
  <div>
  <headerComponent />
</div>
  <div >
    <router-view />
  </div>
  <div >
  <footerComponet />
  <div>
  <a class="whatsapp-float1" @click="showPhonePopup = true">
    <v-icon class="whatsappImg1">mdi-phone</v-icon>
  </a>
</div>
<div v-if="showPhonePopup" class="popup-box">
  <div class="popup-header">
   <span @click="showPhonePopup = false"><v-icon class="ml-1">mdi-close</v-icon></span>
  </div>
  <div class="popup-body">
    <a  :href="`tel:${whatsappApi}`" class="popup-number"  rel="noopener noreferrer"><v-icon size="20">mdi-phone</v-icon> {{ whatsappApi }}</a>
  </div>
</div>
<div >
  
          <a :href="`https://wa.me/${whatsappApi.replace(/\D/g, '')}`" class="whatsapp-float" target="_blank" rel="noopener noreferrer">
            <v-icon class="whatsappImg">mdi-whatsapp</v-icon>
          </a>
        </div>

</div>
</template>

<script>
import headerComponent from "@/components/headerComponent.vue";
import footerComponet from "@/components/footerComponet.vue";
import axios from "axios"
export default {
   components: {
      headerComponent,
      footerComponet},
  name: "App",
  data() {
    return {
        showPhonePopup: false,
         whatsappApi: "",
         phone:""
    };
  },
  methods:{
     async getIpAddress() {
  try {
    const response = await axios.get("https://ipwho.is/");
    console.log(response.data, "ipadd");
if(response.data.country_code == "IN"){
  this.whatsappApi ="+91 81242 43000"
}
else if(response.data.country_code == "AU"){
  this.whatsappApi ="+61 452 201 075"
}
else if(response.data.country_code == "LK"){
  this.whatsappApi ="+94 777 312 606"
}
else if(response.data.country_code == "CH"){
  this.whatsappApi ="+41 44 315 5840"
}
else{
  this.whatsappApi ="+61 452 201 075"
}
 
  } catch (err) {
    console.error("IP fetch error:", err);
  }
},
  },
 
  created(){
this.getIpAddress()
  }
 
};
</script>

<style>
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: lightgray;
  border-radius: 5px;
}

.whatsapp-float:hover {
  color: white;
  transform: scale(1.2); /* grows 20% larger */
}

.whatsapp-float .whatsappImg {
  font-size: 30px;
  top: 0px;
  left: 1px;
    color: white;
}

.whatsapp-float1:hover {
  color: white;
  transform: scale(1.2); /* grows 20% larger */
}
.whatsapp-float1:active {
  color: white;
}
.whatsapp-float1 .whatsappImg1 {
  font-size: 30px;
  top: 1px;
  left: 8px;
} .whatsapp-float1 {
  position: fixed;
  bottom: 50px;
  right: 30px;
  background-color: #081565;
  color: white;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  /* display: flex;
  justify-content: center;
  align-items: center; */
  box-shadow: 1px 1px 5px rgba(0,0,0,0.3);
  z-index: 10000000 !important;
  cursor: pointer;
    font-size: 22px;
  text-decoration: none;
}

.whatsappImg1 {
  font-size: 26px;
}.popup-box {
  position: fixed;
  bottom: 90px;
  right: 30px;
  width: 250px;
  border-radius: 10px;
  box-shadow: 0 0 8px rgba(0,0,0,0.3);
  overflow: hidden;
  background-color: white;
  z-index: 10000000 !important;
  animation: fadeIn 0.3s ease;
}
.popup-header {
  background: linear-gradient(0deg, #c60000 0%, #ff0000 100%);
  color: white;
  padding: 6px;
  font-weight: bold;
  display: flex;
  align-items: center;
  font-size: 16px;
  justify-content: space-between;
}

.popup-body {
  padding: 20px;
  text-align: center;
}

.popup-number {
  font-size: 20px;
  font-weight: bold;
  color: #000;
  text-decoration: none;
}
.popup-number:active{
  color: #000;
}
.whatsapp-float {
  position: fixed;
  width: 45px;
  height: 45px;
  bottom: 115px;
  right: 30px;
  background-color: #25d366;
  color: #ffffff;
  border-radius: 50px;
  text-align: center;
  font-size: 22px;
  z-index:99999;
  box-shadow: 1px 1px 2px #888;
  transition: transform 0.3s ease; /* smooth grow effect */
}

.whatsapp-float:hover {
  color: white;
  transform: scale(1.2); /* grows 20% larger */
}

.whatsapp-float .whatsappImg {
  font-size: 30px;
  top: 0px;
  left: 1px;
}

.whatsapp-float1:hover {
  color: white;
  transform: scale(1.2); /* grows 20% larger */
}
.whatsapp-float1:active {
  color: white;
}
.whatsapp-float1 .whatsappImg1 {
  font-size: 30px;
  top: 1px;
  left: 8px;
} 
</style>
